import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { PrintableDocument } from "./print-job";

export const DocumentTypeSchema = createEnum(PrintableDocument, {
  enumName: "PrintableDocument",
});

export const PrintableDocumentsDisplayName = {
  [PrintableDocument.PICK_LIST]: "Shipping label",
  [PrintableDocument.PACKING_SLIP]: "Packing slip",
  [PrintableDocument.LABEL]: "Shipping label",
  [PrintableDocument.COMMERCIAL_INVOICE]: "Commercial invoice",
  [PrintableDocument.PERSONALIZED_SLIP]: "Personalized slip",
  [PrintableDocument.RETURN_LABEL]: "Return label",
  [PrintableDocument.LOCAL_PICK_UP_LABEL]: "Local pick up label",
  [PrintableDocument.BILL_OF_LADING]: "Bill of lading",
  [PrintableDocument.PARCEL_PACKING_SLIP]: "Package packing slip",
  [PrintableDocument.ORDER_SUMMARY]: "Order summary",
};

// TODO: Migrate this to PrintableDocument
export enum PrintKind {
  PICK_LIST = "pickListPrinted",
  PACKING_SLIP = "packingSlipPrinted",
  LABEL = "labelPrinted",
  COMMERCIAL_INVOICE = "commercialInvoicePrinted",
  PERSONALIZED_SLIP = "personalizedSlipPrinted",
  RETURN_LABEL = "returnLabelPrinted",
  LOCAL_PICK_UP_LABEL = "localPickUpLabelPrinted",
  BILL_OF_LADING = "billOfLadingPrinted",
  PARCEL_PACKING_SLIP = "parcelPackingSlipPrinted",
  ORDER_SUMMARY = "orderSummaryPrinted",
}

export const PrintKindForDocument: Record<PrintableDocument, PrintKind> = {
  [PrintableDocument.PICK_LIST]: PrintKind.PICK_LIST,
  [PrintableDocument.PACKING_SLIP]: PrintKind.PACKING_SLIP,
  [PrintableDocument.LABEL]: PrintKind.LABEL,
  [PrintableDocument.COMMERCIAL_INVOICE]: PrintKind.COMMERCIAL_INVOICE,
  [PrintableDocument.PERSONALIZED_SLIP]: PrintKind.PERSONALIZED_SLIP,
  [PrintableDocument.RETURN_LABEL]: PrintKind.RETURN_LABEL,
  [PrintableDocument.LOCAL_PICK_UP_LABEL]: PrintKind.LOCAL_PICK_UP_LABEL,
  [PrintableDocument.BILL_OF_LADING]: PrintKind.BILL_OF_LADING,
  [PrintableDocument.PARCEL_PACKING_SLIP]: PrintKind.PARCEL_PACKING_SLIP,
  [PrintableDocument.ORDER_SUMMARY]: PrintKind.ORDER_SUMMARY,
};

const PrintStatusSchema_ = z.object({
  [PrintKind.PICK_LIST]: z.boolean().nullish(),
  [PrintKind.PACKING_SLIP]: z.boolean().nullish(),
  [PrintKind.LABEL]: z.boolean().nullish(),
  [PrintKind.COMMERCIAL_INVOICE]: z.boolean().nullish(),
  [PrintKind.PERSONALIZED_SLIP]: z.boolean().nullish(),
  [PrintKind.RETURN_LABEL]: z.boolean().nullish(),
  [PrintKind.LOCAL_PICK_UP_LABEL]: z.boolean().nullish(),
  [PrintKind.BILL_OF_LADING]: z.boolean().nullish(),
  [PrintKind.PARCEL_PACKING_SLIP]: z.boolean().nullish(),
  [PrintKind.ORDER_SUMMARY]: z.boolean().nullish(),
  packingSlipPrintedAt: z.date().nullish(),
});

export const PrintStatusSchema: z.ZodType<PrintStatus> = PrintStatusSchema_;

export interface PrintStatus extends z.infer<typeof PrintStatusSchema_> {}
